<template>
  <base-box class="box-coupon no-shadow p_0">
    <div
      :class="`p_20 pb_10 ${!expired ? 'pointer' : ''}`"
      @click="
        !expired && changeRoute('resultados-cupom', { code: oCoupon.code })
      "
    >
      <div class="d-flex align-center justify-between mb_25">
        <div class="d-flex align-center">
          <i :class="[ticketIconClass, 'fas fa-ticket-alt fa-3x']"></i>
          <p :class="[cuponCodeClass, 'field-title']">{{ oCoupon.code }}</p>
        </div>
      </div>

      <div class="d-flex align-center justify-between mb_15">
        <div>
          <p :class="titleClass">Benefício oferecido</p>
          <p>{{ couponAmount }}</p>
        </div>
        <div class="text-right">
          <p :class="titleClass">Modo de uso</p>
          <p>{{ couponType }}</p>
        </div>
      </div>

      <div class="d-flex align-center justify-between mb_25">
        <div>
          <p :class="titleClass">Valor em vendas</p>
          <p>{{ couponSalesValue }}</p>
        </div>
        <div class="text-right">
          <p :class="titleClass">Data de expiração</p>
          <p>{{ couponExpiration }}</p>
        </div>
      </div>

      <div v-if="expired" class="d-flex align-center">
        <base-button
          @click="changeRoute('resultados-cupom', { code: oCoupon.code })"
          class="w-100 mr_7 state-btn"
          design="four"
          >Ver detalhes</base-button
        >
        <base-button
          @click="reactiveCoupon"
          class="w-100 ml_7 state-btn"
          design="two"
          >Reativar cupom</base-button
        >
      </div>

      <div
        v-if="!expired"
        @click="changeRoute('resultados-cupom', { code: oCoupon.code })"
        class="d-flex justify-center flex-column align-center"
      >
        <p class="see-details">Ver detalhes</p>
        <div />
      </div>

      <coupons-reactivation
        v-if="expired"
        :couponCode="oCoupon.code"
        :open="reactiveDrawer.open"
        :close="reactiveDrawer.close"
        @onFinishReactivation="onFinishReactivation"
      />
    </div>
  </base-box>
</template>
<script>
import dayjs from 'dayjs';
import Gift, { TYPE as aTypes } from 'easyjs/lib/Schema/Gift';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import CouponsReactivation from '@/containers/Coupons/Forms/CouponsReactivation';
import GiftAPI from '@/api/coupon';
import Utils from '@/utils';
import ApiReports from '@/api/reports';

export default {
  props: {
    expired: { type: Boolean, required: false, default: false },
    coupon: { type: Object, required: true, default: {} },
  },
  data() {
    return {
      ticketIconClass: this.expired ? 'ticket-icon-expired' : 'ticket-icon',
      cuponCodeClass: this.expired ? 'coupon-code-expired' : 'coupon-code',
      titleClass: this.expired ? 'field-title-expired' : 'field-title',
      oCoupon: {},
      couponReport: {
        total: 0,
        sales: 0,
      },
      reactiveDrawer: {
        open: false,
        close: false,
      },
    };
  },
  created() {
    this.oCoupon = Gift.fromObject(this.coupon);
    this.getCouponUseReport();
  },
  methods: {
    changeRoute(routeName, params = {}) {
      this.$router.push({ name: routeName, params });
    },
    reactiveCoupon() {
      // const { code, expiration } = this.oCoupon;
      // const verifyExpiration = expiration || 999999999999;
      // confirm(`Deseja mesmo Reativar o cupom "${code}" ?`, (res) => {
      //   if (!res) return;
      //   return GiftAPI.reactivate(code, verifyExpiration).then((response) => {
      //     if (response.getErrors([]).lengt > 0) {
      //       return alert('Houve um problema ao reativar esse cupom.');
      //     }
      //     this.$router.push({ name: 'cupons' });
      //   });
      // });
      this.reactiveDrawer.open = !this.reactiveDrawer.open;
      // this.$emit('onFinishReactivation');
    },
    onFinishReactivation() {
      this.reactiveDrawer.close = !this.reactiveDrawer.close;
    },
    getCouponUseReport() {
      const esFilter = {
        query: [
          {
            index: 'report-orders',
            type: 'aggs',
            queries: [
              {
                query_string: {
                  query: `${this.oCoupon.code}`,
                  fields: ['gift.code'],
                },
              },
              {
                bool: {
                  should: [
                    {
                      match: {
                        status: 4,
                      },
                    },
                    {
                      match: {
                        status: -1,
                      },
                    },
                  ],
                },
              },
            ],
            aggs: {
              couponUse: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: '1901-01-01',
                      to: dayjs().format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                    },
                  ],
                },
                aggs: {
                  total: {
                    nested: {
                      path: 'payers',
                    },
                    aggs: {
                      total: {
                        sum: {
                          field: 'payers.amount',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      };

      ApiReports.reports(esFilter).then((response) => {
        const bucket = response.data[0].couponUse.buckets[0];

        this.couponReport.total = bucket.total.doc_count;
        this.couponReport.sales = bucket.total.total.value;
      });
    },
  },
  computed: {
    couponAmount() {
      if (this.oCoupon.typeIs(aTypes.DELIVERY)) {
        return 'Entrega Grátis';
      }

      if (this.oCoupon.typeIs(aTypes.PERCENT)) {
        return `${this.oCoupon.value}%`;
      }

      if (this.oCoupon.typeIs(aTypes.PRICE)) {
        return Utils.convertMoney(this.oCoupon.value, 'R$', '');
      }
    },
    couponType() {
      if (this.oCoupon.typeIs(aTypes.FREE_TO_USE)) {
        return 'Usos ilimitados por cadastro';
      }

      if (this.oCoupon.typeIs(aTypes.N_USE)) {
        return 'Uso único por cadastro';
      }
    },
    couponSalesValue() {
      return Utils.convertMoney(this.couponReport.sales);
    },
    couponExpiration() {
      return this.oCoupon.expiration
        ? Utils.ts2Date(this.oCoupon.expiration, false)
        : '---';
    },
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    CouponsReactivation,
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.coupon-code {
  font-size: 1.6em !important;
  color: var(--default-hover) !important;
}
.coupon-code-expired {
  font-size: 1.6em !important;
  font-weight: bold;
  color: #aaaaab !important;
}
.field-title,
.field-title-expired {
  text-transform: uppercase;
  color: #bfbfbf;
  font-weight: bold;
  font-size: 1.2em;
}
.field-title + p,
.field-title-expired + p {
  font-size: 1.2em;
  color: #bfbfbf;
  margin-top: 5px;
}
.ticket-icon {
  color: var(--default);
  margin-right: 15px;
  font-size: 1.9em;
}
.ticket-icon-expired {
  color: #aaaaab;
  font-size: 1.9em;
  margin-right: 15px;
}
.see-details {
  cursor: pointer;
  font-size: 1.2em;
  color: #ffffff;
  text-transform: uppercase;
}

.see-details + div {
  margin-top: 5px;
  margin-bottom: 4px;
  background: #fff;
  height: 1px;
  width: 85px;
  opacity: 0;
}
.see-details:hover + div {
  opacity: 1;
}

@media screen and (max-width: 991px) {
  .see-details {
    font-size: 1.2em;
  }
  .field-title,
  .field-title + p {
    font-size: 1em;
  }
  .box {
    padding-bottom: 15px;
  }
  .coupon-code-expired,
  .coupon-code {
    font-size: 1.4em !important;
  }
  .ticket-icon-expired {
    margin-right: 10px !important;
  }
  .field-title,
  .field-title-expired {
    font-size: 1em;
  }
  .field-title + p,
  .field-title-expired + p {
    font-size: 1em;
  }
}
</style>
